import type { FetchRequestArgs } from '../../utils';
import { fetchRequest, sanitizeBuilderQuery } from '../../utils';
import { HTTPMethod } from '../httpMethods';

export const readGroupBuilderPreview = async <
  T extends Record<string, unknown>,
>({
  query,
  boardId,
  data: { builderQuery, ...restData },
  domain,
  headers,
  limit,
  offset,
}: FetchRequestArgs & {
  boardId: string;
  limit: number;
  offset: number;
  data: { builderQuery: Record<string, unknown> };
}): Promise<ReturnType<typeof fetchRequest>> =>
  fetchRequest<T>({
    data: { builderQuery: sanitizeBuilderQuery(builderQuery), ...restData },
    domain,
    endpoint: `/query/${boardId}/builder`,
    headers,
    method: HTTPMethod.POST,
    query: {
      ...query,
      limit,
      offset,
    },
  });
